import React, { FC } from 'react';
import './MediaField.css';
import { ErrorMessage, useFormikContext } from '@/Shared/Lib/Logic';
import { FaImage, FaImages, FaVideo } from 'react-icons/fa';
import { useUploadFile } from '@/Shared/Logic/Hooks/TechnicalHooks/useUploadFile';
import { UploadedMedia } from '@/Shared/Types';


interface MediaFieldProps<T> {
	label: string,
	name: string,
	placeholder?: string,
	type?: string,
	autoComplete?: string,
	multiple?: boolean,
	fieldValues: UploadedMedia[]
}

const MediaField: FC<MediaFieldProps<any>> = ({
	label,
	name,
	placeholder,
	type = 'image',
	autoComplete,
	multiple = false,
	fieldValues,
}) => {

	const { setFieldValue } = useFormikContext<any>();
	const { upload } = useUploadFile(fieldValues, setFieldValue);

	const getIcon = () => {

		if (type === 'video') {
			return <FaVideo />
		}

		if (type === 'image') {
			return multiple ? <FaImages /> : <FaImage />;
		}
		return "";
	}


	return (
		<label className="MediaField data-field-label" data-testid="MediaField">
			{label}
			<div className="form-group">
				<div className='Field-wrapper'>
					<div className='file-placeholder'>{getIcon()} {placeholder || label}</div>
					<input
						hidden
						multiple={multiple}
						name={name}
						type='file'
						className="input-field"
						autoComplete={autoComplete || 'off'}
						accept={type === 'image' ? 'image/*' : 'video/*'}
						onChange={event => upload(event, name)}
					/></div>

				<ErrorMessage name={`${name}.large`} component="div" className="error-message" />
				<ErrorMessage name={`${name}.small`} component="div" className="error-message" />
			</div>
		</label>
	);
}

export default MediaField;
